.root {
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 18px 20px;
}

.title-row {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.title-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.icon {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 8px;
  color: var(--color-primary);
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.actions {
  align-items: center;
  display: flex;
  gap: 4px;
}

